import { SvgIcon, SvgIconProps } from '@mui/material'

const JaryanOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_635_671)">
        <path
          d="M12.5 5C11.5717 5 10.6815 5.36875 10.0251 6.02513C9.36875 6.6815 9 7.57174 9 8.5C9 9.42826 9.36875 10.3185 10.0251 10.9749C10.6815 11.6313 11.5717 12 12.5 12C13.4283 12 14.3185 11.6313 14.9749 10.9749C15.6313 10.3185 16 9.42826 16 8.5C16 7.57174 15.6313 6.6815 14.9749 6.02513C14.3185 5.36875 13.4283 5 12.5 5ZM12.5 7C12.8978 7 13.2794 7.15804 13.5607 7.43934C13.842 7.72064 14 8.10218 14 8.5C14 8.89782 13.842 9.27936 13.5607 9.56066C13.2794 9.84196 12.8978 10 12.5 10C12.1022 10 11.7206 9.84196 11.4393 9.56066C11.158 9.27936 11 8.89782 11 8.5C11 8.10218 11.158 7.72064 11.4393 7.43934C11.7206 7.15804 12.1022 7 12.5 7ZM6 8C5.33696 8 4.70107 8.26339 4.23223 8.73223C3.76339 9.20107 3.5 9.83696 3.5 10.5C3.5 11.44 4.03 12.25 4.79 12.68C5.15 12.88 5.56 13 6 13C6.44 13 6.85 12.88 7.21 12.68C7.58 12.47 7.89 12.17 8.12 11.81C7.39 10.86 7 9.7 7 8.5C7 8.41 7 8.31 7 8.22C6.7 8.08 6.36 8 6 8ZM19 8C18.64 8 18.3 8.08 18 8.22C18 8.31 18 8.41 18 8.5C18 9.7 17.61 10.86 16.88 11.81C17 12 17.13 12.15 17.28 12.3C17.44 12.45 17.6 12.58 17.79 12.68C18.15 12.88 18.56 13 19 13C19.44 13 19.85 12.88 20.21 12.68C20.97 12.25 21.5 11.44 21.5 10.5C21.5 9.83696 21.2366 9.20107 20.7678 8.73223C20.2989 8.26339 19.663 8 19 8ZM12.5 14C10.16 14 5.5 15.17 5.5 17.5V19H19.5V17.5C19.5 15.17 14.84 14 12.5 14ZM5.21 14.55C3.28 14.78 0.5 15.76 0.5 17.5V19H3.5V17.07C3.5 16.06 4.19 15.22 5.21 14.55ZM19.79 14.55C20.81 15.22 21.5 16.06 21.5 17.07V19H24.5V17.5C24.5 15.76 21.72 14.78 19.79 14.55ZM12.5 16C14.03 16 15.74 16.5 16.73 17H8.27C9.26 16.5 10.97 16 12.5 16Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_635_671">
          <rect
            width="24"
            height="24"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default JaryanOutlinedIcon
